import PolyFills from './utils/ie_polyfills';
import {uiMsg} from './utils/Languages';
import React from 'react';
import ReactDOM from 'react-dom';
import AppLayout from './AppLayout';
import injectTapEventPlugin from 'react-tap-event-plugin';
import AppModel from './DataModel/AppModel';
import AppModelUtils from './DataModel/AppModelUtils';
import { Router, Route, Link, useRouterHistory } from 'react-router';
import JobsPage from './pages/JobsPage';
import JobPage from './pages/JobPage';
import GraphPage from './pages/GraphPage';
import LoggedOutPage from './pages/LoggedOutPage';
import Dashboard from './pages/Dashboard';
import MachinesPage from './pages/MachinesPage';
import MachinesAdminPage from './pages/MachinesAdminPage';
import MachinePage from './pages/MachinePage';
import NewMachinePage from './pages/NewMachinePage';
import RoomsPage from './pages/RoomsPage';
import NewRoomPage from './pages/NewRoomPage';
import EditRoomPage from './pages/EditRoomPage';
import UserAdminPage from './pages/UserAdminPage';
import EditUserPage from './pages/EditUserPage';
import NewUserPage from './pages/NewUserPage';
import ImpersonatePage from './pages/ImpersonatePage';
import DeletionsPage from './pages/DeletionsPage';
import SupportInfoPage from "./pages/SupportInfoPage";
import ConfirmPhoneNumberPage from "./pages/ConfirmPhoneNumberPage";
import MachineEditConfigPage from "./pages/MachineEditConfigPage";
import CustomersPage  from "./pages/CustomersPage";
import CustomerEditPage  from "./pages/CustomerEditPage";
import NewCustomerPage  from "./pages/NewCustomerPage";
import AssignMachinePage  from "./pages/AssignMachinePage";
import MachineContractsPage  from "./pages/MachineContractsPage";
import ContractEditPage  from "./pages/ContractEditPage";
import NewContractPage  from "./pages/NewContractPage";
import BeaconsPage from "./pages/BeaconsPage";
import SimCardPage from "./pages/SimCardPage";
import SimCardDetailPage from './pages/SimCardDetailPage';
import MachineHistoryPage from './pages/MachineHistoryPage';

import UserManualPage  from "./pages/UserManualPage";


// import { createHistory, useBasename } from "history";
import traceObj from "./utils/stackTraceCatcher";

// This is the history-module installed as a dependency of react Router
// e.g. no entry in package.js, which is odd.  The reason we have to
// use 'history' directly, is that I cannot find React Router provides
// any way to setting basename.  If you install history directly, there
// are version-issues (React Router requiring old version of history...)
import { createHistory } from 'history';
import AuditLogPage from "./pages/AuditLogPage";
import Beacon from './DataModel/Beacon';

// Setting the base path correctly, makes the routes work even if the
// actual path has a prefix.
let base_path = '';
var detectBase = window.location.pathname;
//console.log("window.location="+detectBase);
if(detectBase.search('android_asset')>-1) {
  base_path = '/android_asset/www';
}
if(detectBase.search('rui')>-1) {
  base_path = '/rui';
}
//console.log("Using base-path = "+base_path);

const history = useRouterHistory(createHistory)({
  basename: base_path
})

// Listen for changes in the URL location, and map these to
// more readable UI page names.
let unlisten = history.listen(location => {
  console.log("Location="+location.pathname);
})

// Helper method that sets the selectedNavLinkIndex variable based on
// the route path, to highlight our current position in the nav-menu.
function updateNavigationMark(nextState) {
  //console.log("nextState");
  //console.log(nextState);
  if(nextState.routes && nextState.routes.length>1) {
    var navPath = nextState.routes[1].path || nextState.routes[1].nav_path;
    // Special case for index.html which seems to be required for hybrid wrap
    if(navPath=='index.html') {navPath='home'};
    // Special case for the settings page as it URL depends on logged in user
    if(navPath && navPath == "settings/:id_customer/:id_user") {
        navPath = `settings/${AppModel.id_customer}/${AppModel.id_user}`;
    }
    AppModel.selectedNavLinkIndex=navPath;
    console.log("Setting AppModel.selectedNavLinkIndex = "+navPath)
  }
  else {
    AppModel.selectedNavLinkIndex=null;
  }

}

function routeChangeHandler(nextState,replace) {
  // We set a pageTitle on each leaf route, which is picked up
  // here when routes changes.
  var leafRoute = nextState.routes[nextState.routes.length-1];
  // High/dark-ligth the selected navigation choice in the nav menu:
  updateNavigationMark(nextState);
  // Page components may set their title as a "title" attribute
  // on the component class.
  if(leafRoute.component.title) {
    AppModel.title = leafRoute.component.title;
  }
  // Page titles can also be set/overridden on the route config
  if(leafRoute.pageTitleId) {
    AppModel.titleId = leafRoute.pageTitleId;
    AppModel.title = uiMsg(leafRoute.pageTitleId);
  }
  // If there is a known dataset required for the given route
  // or an array of them.. :  They will load in the background, we
  // do not wait to flip page for them to complete loading.  If the
  // page depend on waiting, use PageLoading component to show users
  // when loading is happening/done:
  if(leafRoute.dataset) {
    if(Array.isArray(leafRoute.dataset)) {
      leafRoute.dataset.forEach(function(dataset){
        AppModelUtils.requireDataset(dataset,nextState.params);
      })
    }
    else {
      AppModelUtils.requireDataset(leafRoute.dataset,nextState.params);
    }
  }
  //
  if(leafRoute.fullScreen) {
    AppModel.uiSession.fullScreen = true;
  }
  else {
    AppModel.uiSession.fullScreen = false;
  }

}

//Needed for onTouchTap
//Can go away when react 1.0 release
//Check this repo:
//https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();

// The entire navigation of the app is defined in this routing table
// The history property must be passed down to all routes.
// TODO : See if history could probably be set on a global route context.
// Each route also specifies a required dataset by name.  This named
// dataset will trigger loading of the required data into the application
// model.
// Each route may also specify "fullScreen:true" - default is false.

const routes = {
  path: '/',
  component: AppLayout,
  indexRoute: { component: Dashboard,
                onEnter:routeChangeHandler,
                pageTitleId:'PT_DECONX', // Decon-X,
                dataset:"user_dashboard",
                nav_path: 'home', // Set to get the Home page nav menu selected
              },
  childRoutes: [
    // Each route also defines which data-set it needs.  The implementation
    // of data-set loading is in DataModel/AppModelUtils
    { path: 'index.html', // Hybrid wrapped app has index.html as entry
      onEnter:routeChangeHandler,
      pageTitleId:'PT_DECONX', // Decon-X,
      component: Dashboard,
      dataset:"user_dashboard"
    },
    { path: 'home', // Hybrid wrapped app has index.html as entry
      onEnter:routeChangeHandler,
      pageTitleId:'PT_DECONX', // Decon-X,
      component: Dashboard,
      dataset:"user_dashboard"
    },
    { path: 'loggedOut', //
      onEnter:routeChangeHandler,
      pageTitleId:'PT_LOGGED_OUT', // Logged Out,
      component: LoggedOutPage
    },
    { path: 'rooms',
      indexRoute:{
        onEnter:routeChangeHandler,
        pageTitleId:'PT_ROOMS', // Rooms,
        component: RoomsPage,
        dataset:"rooms"
      },
      childRoutes:[
        { path: 'newRoom',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_ADD_NEW_LOCATION', // Add new location,
          component: NewRoomPage,
          dataset:["rooms","customer_job_types","new_room_form","location_types"]
        },
        { path: 'duplicateRoom',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_ADD_NEW_LOCATION', // Add new location,
          component: NewRoomPage,
          dataset:["rooms","customer_job_types","duplicate_room_form","location_types"]
        },
        { path: 'room/:id_location/edit',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_EDIT_LOCATION', // Edit location,
          component: EditRoomPage,
          dataset:["customer_job_types","location_details", "location_types"]
        },
      ]
    },
    { path: 'settings/:id_customer/:id_user',
      onEnter:routeChangeHandler,
      pageTitleId:'PT_SETTINGS', // Settings,
      component: EditUserPage,
      dataset:["grant_roles","edit_user_details","rooms","language_list"]
    },
    { path: 'impersonate',
      onEnter:routeChangeHandler,
      pageTitleId:'PT_LOGIN_AS', // Log in as user,
      component: ImpersonatePage,
      dataset:"customer_list"
    },
    { path: 'user_admin',
      indexRoute: {
        onEnter:routeChangeHandler,
        pageTitleId:'PT_USER_ADMIN', // User administration,
        component: UserAdminPage,
        dataset:"user_list"
      },
      childRoutes:[
        { path: 'edit_user/:id_customer/:id_user',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_EDIT_USER', // Edit user,
          component: EditUserPage,
          dataset:["grant_roles","edit_user_details","rooms","language_list"]
        },
        { path: 'new_user/:id_customer',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_ADD_NEW_USER', // Add new user,
          component: NewUserPage,
          dataset:["grant_roles","user_list","rooms","new_user_details","language_list"]
        },
      ]
    },
    { path: 'confirm_phone/:id_customer/:id_user',
      onEnter:routeChangeHandler,
      pageTitleId:'PT_CONFIRM_PHONE_NUMBER', // Confirm phone number,
      component: ConfirmPhoneNumberPage,
      dataset:["edit_user_details"]
    },
    { path: 'support',
      onEnter:routeChangeHandler,
      pageTitleId:'PT_SUPPORT', // Support,
      dataset:[],
      component: SupportInfoPage
    },
    { path: 'audit-log',
      onEnter:routeChangeHandler,
      pageTitleId:'PT_AUDIT_LOG', // Support,
      dataset:["audit_log", "user_list", "customer_list"],
      component: AuditLogPage
    },
    { path: 'user_manual',
      onEnter:routeChangeHandler,
      pageTitleId:'PT_USER_MANUAL', // Support,
      dataset:[],
      component: UserManualPage
    },
    { path: 'deletions',
      onEnter:routeChangeHandler,
      pageTitleId:'PT_DELETED', // Deleted,
      dataset:["recent_deletions"],
      component: DeletionsPage
    },
    { path: 'jobs',
      indexRoute: {
        onEnter:routeChangeHandler,
        pageTitleId:'PT_RECENT_JOBS', // Recent jobs,
        component: JobsPage,
        dataset:"recent_jobs"
      },
      childRoutes: [
        { path: 'job/:id_machine/:startTime',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_JOB_DETAILS', // Job details,
          component: JobPage,
          dataset:"job_details"
        },
        { path: 'job/:id_machine/:startTime/graph',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_GRAPH_PAGE', // Graph page,
          component: GraphPage,
          dataset:"job_details",
          fullScreen:true
        },
      ]
    },
    { path: 'machines',
      indexRoute: {
        component: MachinesPage,
        onEnter:routeChangeHandler,
        pageTitleId:'PT_MACHINES', // Machines,
        dataset:"machines"
      },
      childRoutes: [
        { path: 'admin_machine/:id_customer/:id_machine',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_MACHINE_DETAIL', // Machine detail,
          component: MachinePage,
          dataset:"machine_details",
        },
        { path: 'machine/:id_machine',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_MACHINE_DETAIL', // Machine detail,
          component: MachinePage,
          dataset:"machine_details",
        },
        { path: 'edit_machine_config/:id_machine',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_MACHINE_CONFIG', // Machine configuration,
          component: MachineEditConfigPage,
          dataset:"machine_config_details",
        },
        {
          path: 'machine/:id_machine/history',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_MACHINE_HISTORY',
          component: MachineHistoryPage,
          dataset:"machine_history",
        },
      ]
    },
    { path: 'customers',
      indexRoute: {
        component: CustomersPage,
        onEnter:routeChangeHandler,
        pageTitleId:'PT_CUSTOMERS', // Customers,
        dataset:"customer_list"
      },
      childRoutes: [
        // Passing the history object to all child routes - will be available in
        // this.props.route.history
        { path: 'newCustomer',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_REGISTER_NEW_CUSTOMER', // Register new customer,
          // component: NewCustomerPage,
          component: NewCustomerPage,
          dataset:["customer_list","new_customer_form","country_list",
                    "customer_segments","job_types","language_list"]
        },
        { path: 'edit/:id_customer',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_EDIT_CUSTOMER', // Edit customer,
          component: CustomerEditPage,
          dataset:[ "customer_list","customer_edit_details","country_list",
                    "customer_segments","job_types","language_list"]
        },
      ]
    },
    { path: 'machine_admin',
      indexRoute: {
        component: MachinesAdminPage,
        onEnter:routeChangeHandler,
        pageTitleId:'PT_MACHINE_ADMIN', // Machine Administration,
        dataset:["customer_list","machine_search"]
      },
      childRoutes: [
        // Passing the history object to all child routes - will be available in
        // this.props.route.history
        { path: 'newMachine',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_NEW_MACHINE_REGISTRATION', // New machine registration,
          component: NewMachinePage,
          dataset:"customer_list"
        },
        { path: 'assign/:id_machine',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_MACHINE_REASSIGN', // Machine (re)assignment,
          component: AssignMachinePage,
          dataset:["customer_list","machine_assign_form"]
        },
        { path: 'contracts/:id_customer/:id_machine',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_MACHINE_CONTRACTS', // Machine contracts,
          component: MachineContractsPage,
          dataset:["contract_context","machine_contracts"]
        },
        { path: 'contract/:id_customer/:id_machine/:id_contract',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_EDIT_CONTRACTS', // Edit contract,
          component: ContractEditPage,
          dataset:["contract_context","contract_detail"]
        },
        { path: 'newContract/:id_customer/:id_machine',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_NEW_CONTRACTS', // New contract,
          component: NewContractPage,
          dataset:["contract_context","new_contract_form",]
        }
      ]
    },
    { path: 'simcards',
      indexRoute:{
        onEnter:routeChangeHandler,
        pageTitleId:'PT_SIMCARDS', // Beacons,
        component: SimCardPage,
        dataset:["subscription","simcards"]
      },
      childRoutes: [
        // Passing the history object to all child routes - will be available in
        // this.props.route.history
        { path: 'simcard/:phoneNumber',
          onEnter:routeChangeHandler,
          pageTitleId:'PT_SIMCARD', // New contract,
          component: SimCardDetailPage,
          dataset:["simcard", "subscription", 'customer_list']
        }
      ]
    },
    { path: 'beacons',
      indexRoute:{
        onEnter:routeChangeHandler,
        pageTitleId:'PT_BEACONS', // Beacons,
        component: BeaconsPage,
        dataset:"customer_list"
      }
    },
  ]
}

ReactDOM.render(<Router routes={routes} history={history} />, document.getElementById('root'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/